import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { ajaxExceptionMessage } from '@skunexus/utils';

import * as API from '../../api';
import styles from './styles.module.css';

const US_COUNTRY_CODE = 'US';

function AddressTemplate({
    data: { name = '', street1 = '', street2 = '', city = '', postcode = '', region = '', country = '' } = {},
}) {
    return (
        <div>
            <div>{name}</div>
            <div>
                {street1} {street2 && <br />}
                {street2}
            </div>
            <div>{`${city}, ${region}, ${postcode}`}</div>
            {US_COUNTRY_CODE !== country && <div>{country}</div>}
        </div>
    );
}

AddressTemplate.propTypes = {
    data: PropTypes.object,
};

AddressTemplate.defaultProps = {
    data: {},
};

function InterOfficeLabel({ details, errorNotification }) {
    const [warehouse, setWarehouse] = useState({});

    useEffect(() => {
        const fetchWarehouse = async (id) => {
            try {
                const response = await API.fetchWarehouse(id);
                if (response.status !== 200) {
                    throw new Error(`Couldn't load warehouse`);
                }
                setWarehouse(get(response, 'data.data.warehouse.details', {}));
            } catch (e) {
                errorNotification(ajaxExceptionMessage(e));
            }
        };

        if (!isEmpty(details) && get(details, 'fulfillFrom.id')) {
            fetchWarehouse(get(details, 'fulfillFrom.id'));
        }
    }, [details]);

    if (isEmpty(details)) return null;
    return (
        <div className={styles.wrapper}>
            <div className={styles.warehouseAddress}>
                <AddressTemplate data={warehouse} />
            </div>
            <div className={styles.customerAddress}>
                <AddressTemplate
                    data={{
                        name: get(details, 'relatedOrder.customer_name', ''),
                        ...get(details, 'relatedOrder.shippingAddress', {}),
                    }}
                />
            </div>
        </div>
    );
}

InterOfficeLabel.propTypes = {
    details: PropTypes.object,
    errorNotification: PropTypes.func.isRequired,
};

InterOfficeLabel.defaultProps = {
    details: {},
};

export default InterOfficeLabel;
